<template>
    <div class="list-simple" >
        <ul v-if="list.length">
            <li class="am-cf" v-for="(item,index) in list" :key="index"  >
                <div class="title am-text-truncate" :style="date?'':'width:100%'">
                     <el-tag size="mini" v-if="item.port_new=='1'">新</el-tag>
                    <el-tag size="mini" v-if="item.port_top=='1'" type="danger">顶</el-tag>
                     <router-link :to="'/article/'+item.article_id" target="_blank">{{item.title}}</router-link>
                </div>
                <div class="date" v-if="date">
                    {{(item.publish_time||'').substring(5,10)}}
                </div>
            </li>
        </ul>
        <div v-else class="no-data">
            暂无文章
        </div>
    </div>
</template>

<script>
export default {
    props:{
        list:{
            type:Array,
        },
        date:{
            default:true
        }
    }
}
</script>

<style lang="scss">
.list-simple{
    li{
        background-repeat: no-repeat;
        background-position: left;
        font-size: 14px;
        height: 28px;
        line-height: 28px;
        &:hover{
            color: $primary;
        }
        .title{
            width: calc(100% - 100px);
            float: left;
        }
        .date{
            width: 100px;
            float: left;
            text-align: right;
            padding-left: 20px;
            box-sizing: border-box;
        }
    }
}
</style>
